type Props = { amount: number };

export default function NotificationBubble({ amount }: Props) {
  return (
    <div className="absolute bg-red-500 -right-[1em] -top-2 z-10 rounded-full w-4 h-4 text-xxs text-white text-center flex justify-center items-center font-bold">
      {amount > 9 ? '9+' : amount}
    </div>
  );
}
